module.exports = __webpack_public_path__ + "img/frase_sinal_faixa.4b36afe7.svg";